export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Editorial%20fashion%20photography%20diverse%20collection%20of%20sneakers%20handbags%20jackets%20and%20accessories%20artistically%20arranged%20on%20smooth%20marble%20surface%20with%20natural%20daylight%20contemporary%20luxury%20aesthetic%20warm%20neutral%20tones%20soft%20shadows%20sophisticated%20composition%20high%20end%20retail%20catalog%20style&width=1800&height=900&seq=hero-bg-v2&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-semibold tracking-wider uppercase text-primary-300 bg-primary-950/40 backdrop-blur-sm rounded-full">
            Updated 2026 Guide
          </span>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            Basetao Spreadsheet — The Ultimate Guide to Finding the Best Basetao Products
          </h1>

          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover thousands of researched Basetao products, detailed buying guides, shipping information, reviews, coupons, and expert tips — all organized in one powerful spreadsheet resource.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Basetao Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-foreground-900 bg-background-50 hover:bg-background-100 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            <span className="flex items-center gap-2 text-xs text-background-200/80">
              <i className="ri-check-line text-primary-400"></i>
              Updated Guides
            </span>
            <span className="flex items-center gap-2 text-xs text-background-200/80">
              <i className="ri-check-line text-primary-400"></i>
              Shipping Cost Analysis
            </span>
            <span className="flex items-center gap-2 text-xs text-background-200/80">
              <i className="ri-check-line text-primary-400"></i>
              Real User Information
            </span>
            <span className="flex items-center gap-2 text-xs text-background-200/80">
              <i className="ri-check-line text-primary-400"></i>
              Beginner Friendly
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}